<template>
  <div>

    <v-tabs-items
      class="pa-0"
      v-model="activeInfoDrawerTab"
    >

      <v-tab-item
        class="pa-0"
        v-bind:key="key"
        v-for="(category, key) in templateDefinition"
      >
        <v-simple-table
          dense
          class="pa-0"
          v-show="tidsserie && key === 'generalAttributes' || (key === 'feltAttributes' && (tidsserie.stasjonParameter === 'Vannføring' || tidsserie.stasjonParameter === 'Vannstand'))"
        >
          <template v-slot:default>
            <tbody>
              <template v-for="attribute in category.attributes">
                <tr class="no-table-hover"
                  :key="attribute.text"
                  v-if="!attribute.show || attribute.show.includes(tidsserie.stasjonParameter)"
                >
                  <td v-if="!attribute.hide">
                    {{attribute.text}}
                  </td>
                  <td
                    :title="(tidsserie[attribute.value] && tidsserie[attribute.value] != 'Null') ? getFormattedValue(attribute) : 'Ikke angitt'"
                    v-if="!attribute.hide"
                    style="text-align: right; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                  >{{(tidsserie[attribute.value] && tidsserie[attribute.value] != 'Null') ? getFormattedValue(attribute) : 'Ikke angitt'}} </td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>

        <p v-show="key === 'feltAttributes' && (tidsserie.stasjonParameter !== 'Vannføring' && tidsserie.stasjonParameter !== 'Vannstand')">Feltegenskaper er kun tilgjengelig for tidsserier som måler vannføring eller vannstand.</p>

        <div
          class="mt-4"
          v-if="key === 'generalAttributes' && isVannforingSeries"
        >
          <h3 class="ml-2 text-subtitle-1">Kurvekvalitet</h3>
          <table-row-vannforings-kurve
            :key="tidsserie.compoundKey20"
            :timeseries-id="tidsserie.compoundKey20"
          />
          <h3 class="mt-4 ml-2 text-subtitle-1">Fysiske forhold for vannstandsregistrering og vannføringsmåling</h3>
          <table-row-forhold :tidsserie-attributes="tidsserie" />
        </div>

      </v-tab-item>

    </v-tabs-items>

  </div>
</template>

<script>
import TableRowVannforingsKurve from "../../Table/TableRowVannforingsKurve.vue";
import TableRowForhold from "../../Table/TableRowForhold.vue";
import { mapState } from 'vuex';

export default {
  name: "MapPopupTable",
  props: {
    data: Object,
    tidsserie: Object
  },
  components: {
    TableRowVannforingsKurve,
    TableRowForhold
  },
  computed: {
    ...mapState(["activeInfoDrawerTab", "vheaders", "otherTimeseriesHeaders"]),
    isVannforingSeries: function () {
      return this.tidsserie.stasjonParameter === 'Vannføring';
    }
  },
  watch: {
    tidsserie: {
      deep: true,
      handler: function () {
        if (Object.prototype.hasOwnProperty.call(this.tidsserie, 'objektType')) {
          this.templateDefinition.generalAttributes.attributes = this.vheaders.filter(item => {
            return item.category === 'General'
          });
        } else {
          this.templateDefinition.generalAttributes.attributes = this.otherTimeseriesHeaders.filter(item => {
            return item.category === 'General'
          });
        }

        this.templateDefinition.feltAttributes.attributes = this.vheaders.filter(item => {
          return item.category === 'Feltegenskap'
        });
      }
    }
  },
  methods: {
    getFormattedValue: function (attribute) {

      let rawValue = this.tidsserie[attribute.value];

      if (Object.prototype.hasOwnProperty.call(attribute, "valueMapping")) {

        let values = attribute.valueMapping.filter(value => {
          return value.valueFrom === rawValue
        });
        if (values.length > 0) {
          return values[0].valueTo;
        }

      }


      if (Object.prototype.hasOwnProperty.call(attribute, "type") && attribute.type === 'float') {
        rawValue = rawValue.replace(",", ".");
        let floatValue = parseFloat(rawValue);



        let twoDecimalFloat = (Math.round(floatValue * 100) / 100).toFixed(2);
        return twoDecimalFloat.toString().replace(".", ",");
      } else if (Object.prototype.hasOwnProperty.call(attribute, "type") && attribute.type === 'date') {        
        return rawValue.slice(0, 10);
      } else {
        return rawValue;
      }      
    },
    isInt: function (n) {
      return Number(n) === n && n % 1 === 0;
    },

    isFloat: function (n) {
      return Number(n) === n && n % 1 !== 0;
    }
  },
  mounted: function () {

    if (Object.prototype.hasOwnProperty.call(this.tidsserie, 'objektType')) {
      this.templateDefinition.generalAttributes.attributes = this.vheaders.filter(item => {
        return item.category === 'General'
      });
    } else {
      this.templateDefinition.generalAttributes.attributes = this.otherTimeseriesHeaders.filter(item => {
        return item.category === 'General'
      });
    }

    this.templateDefinition.feltAttributes.attributes = this.vheaders.filter(item => {
      return item.category === 'Feltegenskap'
    });

  },
  data () {
    return {
      tab: null,
      templateDefinition: {
        generalAttributes: {
          heading: "Generelle egenskaper",
          attributes: []
        },
        feltAttributes: {
          heading: "Feltegenskaper",
          attributes: [
          ]
        }
      }
    }
  }
};
</script>
<style>
.popup-table {
  width: 100%;
  table-layout: fixed;
  overflow: hidden;
}

.popup-table td,
#customers th {
  border: 0px solid #ddd;
  padding: 8px;
}

.popup-table th {
  padding-top: 12px;
  padding-left: 10px;
  padding-bottom: 12px;
  text-align: left;
  background-color: rgb(94, 94, 94);
  color: white;
}

.popup-table tr {
  border-bottom: 1px solid #f2f2f2;
}

.no-table-hover {
  pointer-events: none;
}
</style>
